import Utils from '@/ecm/common/Utils'
import ContentTypeAlertAction from '@/ecm/models/contentType/alerts/ContentTypeAlertAction'

export default class ContentTypeAlert {
    constructor (dto) {
        this.uuid = Utils.object.getUUID()
        this.conditionStr = ''
        this.displayConditionStr = ''
        this.notifyByEmail = false
        this.actions = []
        this.roleTypes = []
        this.triggerId = 1

        if (dto) {
            this.conditionStr = dto.ConditionStr
            this.displayConditionStr = dto.DisplayConditionStr
            this.notifyByEmail = dto.NotifyByEmail
            this.actions = dto.Actions.map(function (dto) { return new ContentTypeAlertAction(dto) })
            this.roleTypes = dto.RoleTypeIDs.map(x => x + '')
            this.triggerId = dto.ContentTypeAlertTriggerID
        }
    }

    toDto () {
        return {
            ConditionStr: this.conditionStr,
            NotifyByEmail: this.notifyByEmail,
            Actions: this.actions.map(function (action) { return action.toDto() }),
            RoleTypeIDs: this.roleTypes.map(x => parseInt(x)),
            ContentTypeAlertTriggerID: this.triggerId,
        }
    }
}
